/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GLOBAL_FILTER_CONTEXT = "INVOICES" | "LABELS" | "PEOPLE" | "PLACEHOLDERS" | "PROJECTS" | "RESOURCES" | "SKILLS" | "TASKS" | "TIME_REGS" | "%future added value";
export type GLOBAL_FILTER_FIELD = "APPROVAL_STATUS" | "ASSIGNED" | "ASSIGNED_SELF" | "BILLABLE" | "BILLABLE_TIME_REG" | "BILL_FROM" | "BILL_TO" | "BLOCKED" | "BUG" | "CLIENT" | "CLIENT_GUEST_USERS" | "CLIENT_TIME_REG" | "COMPANY_TASK_ID" | "CONTACT" | "CREATED_AT" | "DEADLINE" | "DEPARTMENT" | "DEPARTMENT_TIME_REG" | "DEPENDENCIES" | "DESCRIPTION" | "END_DATE" | "END_DATE_PROJECT" | "END_DATE_TIME_REG" | "FILTER_BY_TIME_REG_SETTINGS" | "FOLLOWER" | "FORECAST" | "HIGH_PRIORITY" | "INTERNAL_TIME" | "INTERNAL_TIME_REG" | "INVOICED" | "LABELS" | "LABEL_TIME_REG" | "NAME" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "NON_TASK_TIME_REG" | "NO_CONTACT" | "OWNER" | "PERMISSION_LEVEL" | "PERSON" | "PERSON_TIME_REG" | "PHASE_CATEGORY" | "PHASE_TIME_REG" | "PRIORITY_LEVEL" | "PROGRAM" | "PROJECT" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "PROJECT_FOLLOWER" | "PROJECT_GROUP" | "PROJECT_GROUP_SPRINT" | "PROJECT_GROUP_STATUS" | "PROJECT_LABELS" | "PROJECT_MANUAL_PROGRESS" | "PROJECT_OWNER" | "PROJECT_PERSON" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_STAGE" | "PROJECT_STATUS" | "PROJECT_TIME_REG" | "PROJECT_WIN_CHANCE" | "RATE_CARD" | "RECENT_ACTIVITY" | "RECENT_TASK_ACTIVITY" | "RECENT_TIME" | "REMAINING" | "RETAINER_PERIOD" | "ROLE" | "ROLE_TIME_REG" | "SET_DONE_AT" | "SKILL" | "SPRINT_CATEGORY" | "SPRINT_TIME_REG" | "STARRED" | "START_DATE" | "START_DATE_PROJECT" | "START_DATE_TIME_REG" | "STATUS" | "SUB_TASKS" | "TASK" | "TASK_APPROVED" | "TASK_HIERARCHY" | "TASK_LEVEL" | "TASK_TIME_REG" | "TEAM" | "TEAM_MEMBER" | "TEAM_TIME_REG" | "TIME_OFF" | "TIME_OFF_TIME_REG" | "TIME_REGS" | "UPDATED_AT" | "WITH_TASKS" | "WITH_TIME_REG" | "%future added value";
export type GLOBAL_FILTER_LOGICAL_OPERATOR = "AND" | "OR" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "ALL_IN" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "IN" | "IS" | "IS_ALL" | "IS_NOT" | "IS_NOT_ALL" | "LESS" | "LESS_OR_EQUAL" | "NOT_ALL_IN" | "NOT_IN" | "%future added value";
export type TaskSearchQueryType = {
    filters?: Array<GlobalSearchFilterType | null> | null | undefined;
};
export type GlobalSearchFilterType = {
    field?: GLOBAL_FILTER_FIELD | null | undefined;
    operator?: GLOBAL_FILTER_OPERATOR | null | undefined;
    value?: Array<string | null> | null | undefined;
    context?: GLOBAL_FILTER_CONTEXT | null | undefined;
    filters?: Array<GlobalSearchFilterType | null> | null | undefined;
    logicalOperator?: GLOBAL_FILTER_LOGICAL_OPERATOR | null | undefined;
};
export type ResourceNumbersBreakdownLoaderQuery_QueryVariables = {
    startYear?: number | null | undefined;
    startMonth?: number | null | undefined;
    startDay?: number | null | undefined;
    endYear?: number | null | undefined;
    endMonth?: number | null | undefined;
    endDay?: number | null | undefined;
    personId?: string | null | undefined;
    count?: number | null | undefined;
    cursor?: string | null | undefined;
    searchQuery?: TaskSearchQueryType | null | undefined;
};
export type ResourceNumbersBreakdownLoaderQuery_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"ResourceNumbersBreakdownLoader_viewer">;
    } | null;
};
export type ResourceNumbersBreakdownLoaderQuery_Query = {
    readonly response: ResourceNumbersBreakdownLoaderQuery_QueryResponse;
    readonly variables: ResourceNumbersBreakdownLoaderQuery_QueryVariables;
};



/*
query ResourceNumbersBreakdownLoaderQuery_Query(
  $startYear: Int
  $startMonth: Int
  $startDay: Int
  $endYear: Int
  $endMonth: Int
  $endDay: Int
  $personId: ID
  $count: Int
  $cursor: String
  $searchQuery: TaskSearchQueryType
) {
  viewer {
    actualPersonId
    component(name: "ResourceNumbersBreakdownLoader")
    ...ResourceNumbersBreakdownLoader_viewer_2LpbYd
    id
  }
}

fragment ResourceNumbersBreakdownLoader_viewer_2LpbYd on Viewer {
  company {
    person(id: $personId) {
      id
      resourceNumbersBreakdown(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, first: $count, after: $cursor, searchQuery: $searchQuery) {
        totalCount
        edges {
          node {
            id
            idleTime {
              id
              name
              isInternalTime
            }
            project {
              id
              companyProjectId
              customProjectId
              name
              projectColor
              projectGroupId
              readOnlyAccess
              fullAccessToProject
              projectOwner {
                id
                fullName
              }
            }
            projectGroup {
              id
              companyProjectGroupId
              name
              color
              readOnlyAccess
            }
            resourceNumbers {
              actualBillableProjectMinutes
              actualNonBillableProjectMinutes
              actualInternalMinutes
              actualTotalMinutes
              actualBillableUtilization
              actualNonBillableUtilization
              actualInternalUtilization
              actualResourceUtilization
              plannedBillableProjectMinutes
              plannedBillableProjectMinutesWin
              plannedBillableProjectMinutesSoft
              plannedBillableProjectMinutesSoftWin
              plannedBillableProjectMinutesHard
              plannedNonBillableProjectMinutes
              plannedNonBillableProjectMinutesWin
              plannedNonBillableProjectMinutesSoft
              plannedNonBillableProjectMinutesSoftWin
              plannedNonBillableProjectMinutesHard
              plannedInternalMinutes
              plannedTotalMinutes
              plannedTotalMinutesWin
              plannedTotalMinutesSoft
              plannedTotalMinutesSoftWin
              plannedTotalMinutesHard
              plannedBillableUtilization
              plannedBillableUtilizationWin
              plannedBillableUtilizationSoft
              plannedBillableUtilizationSoftWin
              plannedBillableUtilizationHard
              plannedNonBillableUtilization
              plannedNonBillableUtilizationWin
              plannedNonBillableUtilizationSoft
              plannedNonBillableUtilizationSoftWin
              plannedNonBillableUtilizationHard
              plannedInternalUtilization
              plannedResourceUtilization
              plannedResourceUtilizationWin
              plannedResourceUtilizationSoft
              plannedResourceUtilizationSoftWin
              plannedResourceUtilizationHard
              plannedBillableTaskAndAllocationsCombined
              plannedNonBillableTaskAndAllocationsCombined
              plannedInternalTimeTaskAndAllocationsCombined
              plannedTotalTimeTaskAndAllocationsCombined
              plannedBillableUtilizationTaskAndAllocationsCombined
              plannedNonBillableUtilizationTaskAndAllocationsCombined
              plannedInternalUtilizationTaskAndAllocationsCombined
              plannedResourceUtilizationTaskAndAllocationsCombined
              plannedBillableTaskAndAllocationsCombinedWin
              plannedNonBillableTaskAndAllocationsCombinedWin
              plannedTotalTimeTaskAndAllocationsCombinedWin
              plannedBillableUtilizationTaskAndAllocationsCombinedWin
              plannedNonBillableUtilizationTaskAndAllocationsCombinedWin
              plannedResourceUtilizationTaskAndAllocationsCombinedWin
              plannedBillableTaskAndAllocationsCombinedSoft
              plannedNonBillableTaskAndAllocationsCombinedSoft
              plannedTotalTimeTaskAndAllocationsCombinedSoft
              plannedBillableUtilizationTaskAndAllocationsCombinedSoft
              plannedNonBillableUtilizationTaskAndAllocationsCombinedSoft
              plannedResourceUtilizationTaskAndAllocationsCombinedSoft
              plannedBillableTaskAndAllocationsCombinedSoftWin
              plannedNonBillableTaskAndAllocationsCombinedSoftWin
              plannedTotalTimeTaskAndAllocationsCombinedSoftWin
              plannedBillableUtilizationTaskAndAllocationsCombinedSoftWin
              plannedNonBillableUtilizationTaskAndAllocationsCombinedSoftWin
              plannedResourceUtilizationTaskAndAllocationsCombinedSoftWin
              plannedBillableTaskAndAllocationsCombinedHard
              plannedNonBillableTaskAndAllocationsCombinedHard
              plannedTotalTimeTaskAndAllocationsCombinedHard
              plannedBillableUtilizationTaskAndAllocationsCombinedHard
              plannedNonBillableUtilizationTaskAndAllocationsCombinedHard
              plannedResourceUtilizationTaskAndAllocationsCombinedHard
              remainingBillableTaskAndAllocationsCombinedWin
              remainingNonBillableTaskAndAllocationsCombinedWin
              remainingTotalTimeTaskAndAllocationsCombinedWin
              remainingBillableUtilizationTaskAndAllocationsCombinedWin
              remainingNonBillableUtilizationTaskAndAllocationsCombinedWin
              remainingResourceUtilizationTaskAndAllocationsCombinedWin
              remainingBillableTaskAndAllocationsCombinedSoft
              remainingNonBillableTaskAndAllocationsCombinedSoft
              remainingTotalTimeTaskAndAllocationsCombinedSoft
              remainingBillableUtilizationTaskAndAllocationsCombinedSoft
              remainingNonBillableUtilizationTaskAndAllocationsCombinedSoft
              remainingResourceUtilizationTaskAndAllocationsCombinedSoft
              remainingBillableTaskAndAllocationsCombinedSoftWin
              remainingNonBillableTaskAndAllocationsCombinedSoftWin
              remainingTotalTimeTaskAndAllocationsCombinedSoftWin
              remainingBillableUtilizationTaskAndAllocationsCombinedSoftWin
              remainingNonBillableUtilizationTaskAndAllocationsCombinedSoftWin
              remainingResourceUtilizationTaskAndAllocationsCombinedSoftWin
              remainingBillableTaskAndAllocationsCombinedHard
              remainingNonBillableTaskAndAllocationsCombinedHard
              remainingTotalTimeTaskAndAllocationsCombinedHard
              remainingBillableUtilizationTaskAndAllocationsCombinedHard
              remainingNonBillableUtilizationTaskAndAllocationsCombinedHard
              remainingResourceUtilizationTaskAndAllocationsCombinedHard
              forecastBillableTaskAndAllocationsCombinedWin
              forecastNonBillableTaskAndAllocationsCombinedWin
              forecastTotalTimeTaskAndAllocationsCombinedWin
              forecastBillableUtilizationTaskAndAllocationsCombinedWin
              forecastNonBillableUtilizationTaskAndAllocationsCombinedWin
              forecastResourceUtilizationTaskAndAllocationsCombinedWin
              forecastBillableTaskAndAllocationsCombinedSoft
              forecastNonBillableTaskAndAllocationsCombinedSoft
              forecastTotalTimeTaskAndAllocationsCombinedSoft
              forecastBillableUtilizationTaskAndAllocationsCombinedSoft
              forecastNonBillableUtilizationTaskAndAllocationsCombinedSoft
              forecastResourceUtilizationTaskAndAllocationsCombinedSoft
              forecastBillableTaskAndAllocationsCombinedSoftWin
              forecastNonBillableTaskAndAllocationsCombinedSoftWin
              forecastTotalTimeTaskAndAllocationsCombinedSoftWin
              forecastBillableUtilizationTaskAndAllocationsCombinedSoftWin
              forecastNonBillableUtilizationTaskAndAllocationsCombinedSoftWin
              forecastResourceUtilizationTaskAndAllocationsCombinedSoftWin
              forecastBillableTaskAndAllocationsCombinedHard
              forecastNonBillableTaskAndAllocationsCombinedHard
              forecastTotalTimeTaskAndAllocationsCombinedHard
              forecastBillableUtilizationTaskAndAllocationsCombinedHard
              forecastNonBillableUtilizationTaskAndAllocationsCombinedHard
              forecastResourceUtilizationTaskAndAllocationsCombinedHard
              billableActualVsPlan
              billableActualVsPlanWin
              billableActualVsPlanSoft
              billableActualVsPlanSoftWin
              billableActualVsPlanHard
              nonBillableActualVsPlan
              nonBillableActualVsPlanWin
              nonBillableActualVsPlanSoft
              nonBillableActualVsPlanSoftWin
              nonBillableActualVsPlanHard
              internalActualVsPlan
              totalActualVsPlan
              totalActualVsPlanWin
              totalActualVsPlanSoft
              totalActualVsPlanSoftWin
              totalActualVsPlanHard
              remainingBillableProjectMinutes
              remainingBillableProjectMinutesWin
              remainingBillableProjectMinutesSoft
              remainingBillableProjectMinutesSoftWin
              remainingBillableProjectMinutesHard
              remainingNonBillableProjectMinutes
              remainingNonBillableProjectMinutesWin
              remainingNonBillableProjectMinutesSoft
              remainingNonBillableProjectMinutesSoftWin
              remainingNonBillableProjectMinutesHard
              remainingInternalMinutes
              remainingTotalMinutes
              remainingTotalMinutesWin
              remainingTotalMinutesSoft
              remainingTotalMinutesSoftWin
              remainingTotalMinutesHard
              remainingBillableUtilization
              remainingBillableUtilizationWin
              remainingBillableUtilizationSoft
              remainingBillableUtilizationSoftWin
              remainingBillableUtilizationHard
              remainingNonBillableUtilization
              remainingNonBillableUtilizationWin
              remainingNonBillableUtilizationSoft
              remainingNonBillableUtilizationSoftWin
              remainingNonBillableUtilizationHard
              remainingInternalUtilization
              remainingResourceUtilization
              remainingResourceUtilizationWin
              remainingResourceUtilizationSoft
              remainingResourceUtilizationSoftWin
              remainingResourceUtilizationHard
              remainingBillableTaskAndAllocationsCombined
              remainingNonBillableTaskAndAllocationsCombined
              remainingInternalTimeTaskAndAllocationsCombined
              remainingTotalTimeTaskAndAllocationsCombined
              remainingBillableUtilizationTaskAndAllocationsCombined
              remainingInternalUtilizationTaskAndAllocationsCombined
              remainingResourceUtilizationTaskAndAllocationsCombined
              forecastBillableProjectMinutes
              forecastBillableProjectMinutesWin
              forecastBillableProjectMinutesSoft
              forecastBillableProjectMinutesSoftWin
              forecastBillableProjectMinutesHard
              forecastNonBillableProjectMinutes
              forecastNonBillableProjectMinutesWin
              forecastNonBillableProjectMinutesSoft
              forecastNonBillableProjectMinutesSoftWin
              forecastNonBillableProjectMinutesHard
              forecastInternalMinutes
              forecastTotalMinutes
              forecastTotalMinutesWin
              forecastTotalMinutesSoft
              forecastTotalMinutesSoftWin
              forecastTotalMinutesHard
              forecastBillableUtilization
              forecastBillableUtilizationWin
              forecastBillableUtilizationSoft
              forecastBillableUtilizationSoftWin
              forecastBillableUtilizationHard
              forecastNonBillableUtilization
              forecastNonBillableUtilizationWin
              forecastNonBillableUtilizationSoft
              forecastNonBillableUtilizationSoftWin
              forecastNonBillableUtilizationHard
              forecastInternalUtilization
              forecastResourceUtilization
              forecastResourceUtilizationWin
              forecastResourceUtilizationSoft
              forecastResourceUtilizationSoftWin
              forecastResourceUtilizationHard
              forecastBillableTaskAndAllocationsCombined
              forecastNonBillableTaskAndAllocationsCombined
              forecastInternalTimeTaskAndAllocationsCombined
              forecastTotalTimeTaskAndAllocationsCombined
              forecastBillableUtilizationTaskAndAllocationsCombined
              forecastNonBillableUtilizationTaskAndAllocationsCombined
              forecastInternalUtilizationTaskAndAllocationsCombined
              forecastResourceUtilizationTaskAndAllocationsCombined
              tasksEstimateBillableMinutes
              tasksEstimateNonBillableMinutes
              tasksEstimateTotalMinutes
              tasksBillableUtilization
              tasksNonBillableUtilization
              tasksResourceUtilization
              tasksRemainingBillableMinutes
              tasksRemainingNonBillableMinutes
              tasksRemainingTotalMinutes
              tasksRemainingBillableUtilization
              tasksRemainingNonBillableUtilization
              tasksRemainingResourceUtilization
              tasksForecastBillableMinutes
              tasksForecastNonBillableMinutes
              tasksForecastTotalMinutes
              tasksForecastBillableUtilization
              tasksForecastNonBillableUtilization
              tasksForecastResourceUtilization
              tasksBillableActualVsPlan
              tasksNonBillableActualVsPlan
              tasksTotalActualVsPlan
              plannedBillableAllocationVsTask
              plannedBillableAllocationVsTaskWin
              plannedBillableAllocationVsTaskSoft
              plannedBillableAllocationVsTaskSoftWin
              plannedBillableAllocationVsTaskHard
              plannedNonBillableAllocationVsTask
              plannedNonBillableAllocationVsTaskWin
              plannedNonBillableAllocationVsTaskSoft
              plannedNonBillableAllocationVsTaskSoftWin
              plannedNonBillableAllocationVsTaskHard
              plannedAllocationVsTask
              plannedAllocationVsTaskWin
              plannedAllocationVsTaskSoft
              plannedAllocationVsTaskSoftWin
              plannedAllocationVsTaskHard
              remainingBillableAllocationVsTask
              remainingBillableAllocationVsTaskWin
              remainingBillableAllocationVsTaskSoft
              remainingBillableAllocationVsTaskSoftWin
              remainingBillableAllocationVsTaskHard
              remainingNonBillableAllocationVsTask
              remainingNonBillableAllocationVsTaskWin
              remainingNonBillableAllocationVsTaskSoft
              remainingNonBillableAllocationVsTaskSoftWin
              remainingNonBillableAllocationVsTaskHard
              remainingAllocationVsTask
              remainingAllocationVsTaskWin
              remainingAllocationVsTaskSoft
              remainingAllocationVsTaskSoftWin
              remainingAllocationVsTaskHard
              timeOffMinutes
            }
            __typename
          }
          cursor
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
    id
  }
  projectGroups(first: 100000) {
    edges {
      node {
        id
        companyProjectGroupId
        name
        color
        readOnlyAccess
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startYear",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startMonth",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "startDay",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endYear",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endMonth",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "endDay",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "personId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchQuery",
    "type": "TaskSearchQueryType"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "ResourceNumbersBreakdownLoader"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"ResourceNumbersBreakdownLoader\")"
},
v3 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v4 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v5 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v6 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v7 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v8 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v9 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v6/*: any*/),
  (v7/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readOnlyAccess",
  "storageKey": null
},
v14 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "companyProjectGroupId",
    "storageKey": null
  },
  (v12/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "color",
    "storageKey": null
  },
  (v13/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResourceNumbersBreakdownLoaderQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "Variable",
                "name": "personId",
                "variableName": "personId"
              },
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ResourceNumbersBreakdownLoader_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResourceNumbersBreakdownLoaderQuery_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "personId"
                  }
                ],
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": "ResourceNumbersBreakdownTypeConnection",
                    "kind": "LinkedField",
                    "name": "resourceNumbersBreakdown",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ResourceNumbersBreakdownTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ResourceNumbersBreakdown",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IdleTime",
                                "kind": "LinkedField",
                                "name": "idleTime",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isInternalTime",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectType",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "companyProjectId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "customProjectId",
                                    "storageKey": null
                                  },
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "projectColor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "projectGroupId",
                                    "storageKey": null
                                  },
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "fullAccessToProject",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Person",
                                    "kind": "LinkedField",
                                    "name": "projectOwner",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "fullName",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectGroupType",
                                "kind": "LinkedField",
                                "name": "projectGroup",
                                "plural": false,
                                "selections": (v14/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ResourceNumbers",
                                "kind": "LinkedField",
                                "name": "resourceNumbers",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualNonBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualInternalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualInternalUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "actualResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableProjectMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableProjectMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableProjectMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableProjectMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableProjectMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableProjectMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableProjectMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableProjectMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedInternalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedInternalUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedInternalTimeTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalTimeTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedInternalUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalTimeTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalTimeTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalTimeTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedTotalTimeTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedResourceUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalTimeTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalTimeTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalTimeTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalTimeTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalTimeTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationTaskAndAllocationsCombinedWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalTimeTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationTaskAndAllocationsCombinedSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalTimeTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationTaskAndAllocationsCombinedSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalTimeTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationTaskAndAllocationsCombinedHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableActualVsPlanWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableActualVsPlanSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableActualVsPlanSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "billableActualVsPlanHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "nonBillableActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "nonBillableActualVsPlanWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "nonBillableActualVsPlanSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "nonBillableActualVsPlanSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "nonBillableActualVsPlanHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "internalActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalActualVsPlanWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalActualVsPlanSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalActualVsPlanSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "totalActualVsPlanHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableProjectMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableProjectMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableProjectMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableProjectMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableProjectMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableProjectMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableProjectMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableProjectMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingInternalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingInternalUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingInternalTimeTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingTotalTimeTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingInternalUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingResourceUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableProjectMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableProjectMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableProjectMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableProjectMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableProjectMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableProjectMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableProjectMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableProjectMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableProjectMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastInternalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalMinutesWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalMinutesSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalMinutesSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalMinutesHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastInternalUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastInternalTimeTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastTotalTimeTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastBillableUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastNonBillableUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastInternalUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "forecastResourceUtilizationTaskAndAllocationsCombined",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksEstimateBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksEstimateNonBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksEstimateTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksRemainingBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksRemainingNonBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksRemainingTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksRemainingBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksRemainingNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksRemainingResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksForecastBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksForecastNonBillableMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksForecastTotalMinutes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksForecastBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksForecastNonBillableUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksForecastResourceUtilization",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksBillableActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksNonBillableActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "tasksTotalActualVsPlan",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableAllocationVsTask",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableAllocationVsTaskWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableAllocationVsTaskSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableAllocationVsTaskSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedBillableAllocationVsTaskHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableAllocationVsTask",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableAllocationVsTaskWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableAllocationVsTaskSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableAllocationVsTaskSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedNonBillableAllocationVsTaskHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedAllocationVsTask",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedAllocationVsTaskWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedAllocationVsTaskSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedAllocationVsTaskSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "plannedAllocationVsTaskHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableAllocationVsTask",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableAllocationVsTaskWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableAllocationVsTaskSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableAllocationVsTaskSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingBillableAllocationVsTaskHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableAllocationVsTask",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableAllocationVsTaskWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableAllocationVsTaskSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableAllocationVsTaskSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingNonBillableAllocationVsTaskHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingAllocationVsTask",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingAllocationVsTaskWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingAllocationVsTaskSoft",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingAllocationVsTaskSoftWin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "remainingAllocationVsTaskHard",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "timeOffMinutes",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "filters": [
                      "startYear",
                      "startMonth",
                      "startDay",
                      "endYear",
                      "endMonth",
                      "endDay",
                      "searchQuery"
                    ],
                    "handle": "connection",
                    "key": "ResourceNumbersBreakdown_resourceNumbersBreakdown",
                    "kind": "LinkedHandle",
                    "name": "resourceNumbersBreakdown"
                  }
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100000
              }
            ],
            "concreteType": "ProjectGroupTypeConnection",
            "kind": "LinkedField",
            "name": "projectGroups",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectGroupTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectGroupType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v14/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "projectGroups(first:100000)"
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ResourceNumbersBreakdownLoaderQuery_Query",
    "operationKind": "query",
    "text": "query ResourceNumbersBreakdownLoaderQuery_Query(\n  $startYear: Int\n  $startMonth: Int\n  $startDay: Int\n  $endYear: Int\n  $endMonth: Int\n  $endDay: Int\n  $personId: ID\n  $count: Int\n  $cursor: String\n  $searchQuery: TaskSearchQueryType\n) {\n  viewer {\n    actualPersonId\n    component(name: \"ResourceNumbersBreakdownLoader\")\n    ...ResourceNumbersBreakdownLoader_viewer_2LpbYd\n    id\n  }\n}\n\nfragment ResourceNumbersBreakdownLoader_viewer_2LpbYd on Viewer {\n  company {\n    person(id: $personId) {\n      id\n      resourceNumbersBreakdown(startYear: $startYear, startMonth: $startMonth, startDay: $startDay, endYear: $endYear, endMonth: $endMonth, endDay: $endDay, first: $count, after: $cursor, searchQuery: $searchQuery) {\n        totalCount\n        edges {\n          node {\n            id\n            idleTime {\n              id\n              name\n              isInternalTime\n            }\n            project {\n              id\n              companyProjectId\n              customProjectId\n              name\n              projectColor\n              projectGroupId\n              readOnlyAccess\n              fullAccessToProject\n              projectOwner {\n                id\n                fullName\n              }\n            }\n            projectGroup {\n              id\n              companyProjectGroupId\n              name\n              color\n              readOnlyAccess\n            }\n            resourceNumbers {\n              actualBillableProjectMinutes\n              actualNonBillableProjectMinutes\n              actualInternalMinutes\n              actualTotalMinutes\n              actualBillableUtilization\n              actualNonBillableUtilization\n              actualInternalUtilization\n              actualResourceUtilization\n              plannedBillableProjectMinutes\n              plannedBillableProjectMinutesWin\n              plannedBillableProjectMinutesSoft\n              plannedBillableProjectMinutesSoftWin\n              plannedBillableProjectMinutesHard\n              plannedNonBillableProjectMinutes\n              plannedNonBillableProjectMinutesWin\n              plannedNonBillableProjectMinutesSoft\n              plannedNonBillableProjectMinutesSoftWin\n              plannedNonBillableProjectMinutesHard\n              plannedInternalMinutes\n              plannedTotalMinutes\n              plannedTotalMinutesWin\n              plannedTotalMinutesSoft\n              plannedTotalMinutesSoftWin\n              plannedTotalMinutesHard\n              plannedBillableUtilization\n              plannedBillableUtilizationWin\n              plannedBillableUtilizationSoft\n              plannedBillableUtilizationSoftWin\n              plannedBillableUtilizationHard\n              plannedNonBillableUtilization\n              plannedNonBillableUtilizationWin\n              plannedNonBillableUtilizationSoft\n              plannedNonBillableUtilizationSoftWin\n              plannedNonBillableUtilizationHard\n              plannedInternalUtilization\n              plannedResourceUtilization\n              plannedResourceUtilizationWin\n              plannedResourceUtilizationSoft\n              plannedResourceUtilizationSoftWin\n              plannedResourceUtilizationHard\n              plannedBillableTaskAndAllocationsCombined\n              plannedNonBillableTaskAndAllocationsCombined\n              plannedInternalTimeTaskAndAllocationsCombined\n              plannedTotalTimeTaskAndAllocationsCombined\n              plannedBillableUtilizationTaskAndAllocationsCombined\n              plannedNonBillableUtilizationTaskAndAllocationsCombined\n              plannedInternalUtilizationTaskAndAllocationsCombined\n              plannedResourceUtilizationTaskAndAllocationsCombined\n              plannedBillableTaskAndAllocationsCombinedWin\n              plannedNonBillableTaskAndAllocationsCombinedWin\n              plannedTotalTimeTaskAndAllocationsCombinedWin\n              plannedBillableUtilizationTaskAndAllocationsCombinedWin\n              plannedNonBillableUtilizationTaskAndAllocationsCombinedWin\n              plannedResourceUtilizationTaskAndAllocationsCombinedWin\n              plannedBillableTaskAndAllocationsCombinedSoft\n              plannedNonBillableTaskAndAllocationsCombinedSoft\n              plannedTotalTimeTaskAndAllocationsCombinedSoft\n              plannedBillableUtilizationTaskAndAllocationsCombinedSoft\n              plannedNonBillableUtilizationTaskAndAllocationsCombinedSoft\n              plannedResourceUtilizationTaskAndAllocationsCombinedSoft\n              plannedBillableTaskAndAllocationsCombinedSoftWin\n              plannedNonBillableTaskAndAllocationsCombinedSoftWin\n              plannedTotalTimeTaskAndAllocationsCombinedSoftWin\n              plannedBillableUtilizationTaskAndAllocationsCombinedSoftWin\n              plannedNonBillableUtilizationTaskAndAllocationsCombinedSoftWin\n              plannedResourceUtilizationTaskAndAllocationsCombinedSoftWin\n              plannedBillableTaskAndAllocationsCombinedHard\n              plannedNonBillableTaskAndAllocationsCombinedHard\n              plannedTotalTimeTaskAndAllocationsCombinedHard\n              plannedBillableUtilizationTaskAndAllocationsCombinedHard\n              plannedNonBillableUtilizationTaskAndAllocationsCombinedHard\n              plannedResourceUtilizationTaskAndAllocationsCombinedHard\n              remainingBillableTaskAndAllocationsCombinedWin\n              remainingNonBillableTaskAndAllocationsCombinedWin\n              remainingTotalTimeTaskAndAllocationsCombinedWin\n              remainingBillableUtilizationTaskAndAllocationsCombinedWin\n              remainingNonBillableUtilizationTaskAndAllocationsCombinedWin\n              remainingResourceUtilizationTaskAndAllocationsCombinedWin\n              remainingBillableTaskAndAllocationsCombinedSoft\n              remainingNonBillableTaskAndAllocationsCombinedSoft\n              remainingTotalTimeTaskAndAllocationsCombinedSoft\n              remainingBillableUtilizationTaskAndAllocationsCombinedSoft\n              remainingNonBillableUtilizationTaskAndAllocationsCombinedSoft\n              remainingResourceUtilizationTaskAndAllocationsCombinedSoft\n              remainingBillableTaskAndAllocationsCombinedSoftWin\n              remainingNonBillableTaskAndAllocationsCombinedSoftWin\n              remainingTotalTimeTaskAndAllocationsCombinedSoftWin\n              remainingBillableUtilizationTaskAndAllocationsCombinedSoftWin\n              remainingNonBillableUtilizationTaskAndAllocationsCombinedSoftWin\n              remainingResourceUtilizationTaskAndAllocationsCombinedSoftWin\n              remainingBillableTaskAndAllocationsCombinedHard\n              remainingNonBillableTaskAndAllocationsCombinedHard\n              remainingTotalTimeTaskAndAllocationsCombinedHard\n              remainingBillableUtilizationTaskAndAllocationsCombinedHard\n              remainingNonBillableUtilizationTaskAndAllocationsCombinedHard\n              remainingResourceUtilizationTaskAndAllocationsCombinedHard\n              forecastBillableTaskAndAllocationsCombinedWin\n              forecastNonBillableTaskAndAllocationsCombinedWin\n              forecastTotalTimeTaskAndAllocationsCombinedWin\n              forecastBillableUtilizationTaskAndAllocationsCombinedWin\n              forecastNonBillableUtilizationTaskAndAllocationsCombinedWin\n              forecastResourceUtilizationTaskAndAllocationsCombinedWin\n              forecastBillableTaskAndAllocationsCombinedSoft\n              forecastNonBillableTaskAndAllocationsCombinedSoft\n              forecastTotalTimeTaskAndAllocationsCombinedSoft\n              forecastBillableUtilizationTaskAndAllocationsCombinedSoft\n              forecastNonBillableUtilizationTaskAndAllocationsCombinedSoft\n              forecastResourceUtilizationTaskAndAllocationsCombinedSoft\n              forecastBillableTaskAndAllocationsCombinedSoftWin\n              forecastNonBillableTaskAndAllocationsCombinedSoftWin\n              forecastTotalTimeTaskAndAllocationsCombinedSoftWin\n              forecastBillableUtilizationTaskAndAllocationsCombinedSoftWin\n              forecastNonBillableUtilizationTaskAndAllocationsCombinedSoftWin\n              forecastResourceUtilizationTaskAndAllocationsCombinedSoftWin\n              forecastBillableTaskAndAllocationsCombinedHard\n              forecastNonBillableTaskAndAllocationsCombinedHard\n              forecastTotalTimeTaskAndAllocationsCombinedHard\n              forecastBillableUtilizationTaskAndAllocationsCombinedHard\n              forecastNonBillableUtilizationTaskAndAllocationsCombinedHard\n              forecastResourceUtilizationTaskAndAllocationsCombinedHard\n              billableActualVsPlan\n              billableActualVsPlanWin\n              billableActualVsPlanSoft\n              billableActualVsPlanSoftWin\n              billableActualVsPlanHard\n              nonBillableActualVsPlan\n              nonBillableActualVsPlanWin\n              nonBillableActualVsPlanSoft\n              nonBillableActualVsPlanSoftWin\n              nonBillableActualVsPlanHard\n              internalActualVsPlan\n              totalActualVsPlan\n              totalActualVsPlanWin\n              totalActualVsPlanSoft\n              totalActualVsPlanSoftWin\n              totalActualVsPlanHard\n              remainingBillableProjectMinutes\n              remainingBillableProjectMinutesWin\n              remainingBillableProjectMinutesSoft\n              remainingBillableProjectMinutesSoftWin\n              remainingBillableProjectMinutesHard\n              remainingNonBillableProjectMinutes\n              remainingNonBillableProjectMinutesWin\n              remainingNonBillableProjectMinutesSoft\n              remainingNonBillableProjectMinutesSoftWin\n              remainingNonBillableProjectMinutesHard\n              remainingInternalMinutes\n              remainingTotalMinutes\n              remainingTotalMinutesWin\n              remainingTotalMinutesSoft\n              remainingTotalMinutesSoftWin\n              remainingTotalMinutesHard\n              remainingBillableUtilization\n              remainingBillableUtilizationWin\n              remainingBillableUtilizationSoft\n              remainingBillableUtilizationSoftWin\n              remainingBillableUtilizationHard\n              remainingNonBillableUtilization\n              remainingNonBillableUtilizationWin\n              remainingNonBillableUtilizationSoft\n              remainingNonBillableUtilizationSoftWin\n              remainingNonBillableUtilizationHard\n              remainingInternalUtilization\n              remainingResourceUtilization\n              remainingResourceUtilizationWin\n              remainingResourceUtilizationSoft\n              remainingResourceUtilizationSoftWin\n              remainingResourceUtilizationHard\n              remainingBillableTaskAndAllocationsCombined\n              remainingNonBillableTaskAndAllocationsCombined\n              remainingInternalTimeTaskAndAllocationsCombined\n              remainingTotalTimeTaskAndAllocationsCombined\n              remainingBillableUtilizationTaskAndAllocationsCombined\n              remainingInternalUtilizationTaskAndAllocationsCombined\n              remainingResourceUtilizationTaskAndAllocationsCombined\n              forecastBillableProjectMinutes\n              forecastBillableProjectMinutesWin\n              forecastBillableProjectMinutesSoft\n              forecastBillableProjectMinutesSoftWin\n              forecastBillableProjectMinutesHard\n              forecastNonBillableProjectMinutes\n              forecastNonBillableProjectMinutesWin\n              forecastNonBillableProjectMinutesSoft\n              forecastNonBillableProjectMinutesSoftWin\n              forecastNonBillableProjectMinutesHard\n              forecastInternalMinutes\n              forecastTotalMinutes\n              forecastTotalMinutesWin\n              forecastTotalMinutesSoft\n              forecastTotalMinutesSoftWin\n              forecastTotalMinutesHard\n              forecastBillableUtilization\n              forecastBillableUtilizationWin\n              forecastBillableUtilizationSoft\n              forecastBillableUtilizationSoftWin\n              forecastBillableUtilizationHard\n              forecastNonBillableUtilization\n              forecastNonBillableUtilizationWin\n              forecastNonBillableUtilizationSoft\n              forecastNonBillableUtilizationSoftWin\n              forecastNonBillableUtilizationHard\n              forecastInternalUtilization\n              forecastResourceUtilization\n              forecastResourceUtilizationWin\n              forecastResourceUtilizationSoft\n              forecastResourceUtilizationSoftWin\n              forecastResourceUtilizationHard\n              forecastBillableTaskAndAllocationsCombined\n              forecastNonBillableTaskAndAllocationsCombined\n              forecastInternalTimeTaskAndAllocationsCombined\n              forecastTotalTimeTaskAndAllocationsCombined\n              forecastBillableUtilizationTaskAndAllocationsCombined\n              forecastNonBillableUtilizationTaskAndAllocationsCombined\n              forecastInternalUtilizationTaskAndAllocationsCombined\n              forecastResourceUtilizationTaskAndAllocationsCombined\n              tasksEstimateBillableMinutes\n              tasksEstimateNonBillableMinutes\n              tasksEstimateTotalMinutes\n              tasksBillableUtilization\n              tasksNonBillableUtilization\n              tasksResourceUtilization\n              tasksRemainingBillableMinutes\n              tasksRemainingNonBillableMinutes\n              tasksRemainingTotalMinutes\n              tasksRemainingBillableUtilization\n              tasksRemainingNonBillableUtilization\n              tasksRemainingResourceUtilization\n              tasksForecastBillableMinutes\n              tasksForecastNonBillableMinutes\n              tasksForecastTotalMinutes\n              tasksForecastBillableUtilization\n              tasksForecastNonBillableUtilization\n              tasksForecastResourceUtilization\n              tasksBillableActualVsPlan\n              tasksNonBillableActualVsPlan\n              tasksTotalActualVsPlan\n              plannedBillableAllocationVsTask\n              plannedBillableAllocationVsTaskWin\n              plannedBillableAllocationVsTaskSoft\n              plannedBillableAllocationVsTaskSoftWin\n              plannedBillableAllocationVsTaskHard\n              plannedNonBillableAllocationVsTask\n              plannedNonBillableAllocationVsTaskWin\n              plannedNonBillableAllocationVsTaskSoft\n              plannedNonBillableAllocationVsTaskSoftWin\n              plannedNonBillableAllocationVsTaskHard\n              plannedAllocationVsTask\n              plannedAllocationVsTaskWin\n              plannedAllocationVsTaskSoft\n              plannedAllocationVsTaskSoftWin\n              plannedAllocationVsTaskHard\n              remainingBillableAllocationVsTask\n              remainingBillableAllocationVsTaskWin\n              remainingBillableAllocationVsTaskSoft\n              remainingBillableAllocationVsTaskSoftWin\n              remainingBillableAllocationVsTaskHard\n              remainingNonBillableAllocationVsTask\n              remainingNonBillableAllocationVsTaskWin\n              remainingNonBillableAllocationVsTaskSoft\n              remainingNonBillableAllocationVsTaskSoftWin\n              remainingNonBillableAllocationVsTaskHard\n              remainingAllocationVsTask\n              remainingAllocationVsTaskWin\n              remainingAllocationVsTaskSoft\n              remainingAllocationVsTaskSoftWin\n              remainingAllocationVsTaskHard\n              timeOffMinutes\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    id\n  }\n  projectGroups(first: 100000) {\n    edges {\n      node {\n        id\n        companyProjectGroupId\n        name\n        color\n        readOnlyAccess\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '21e3e48e7d0f6f5b0f545b0b4463662c';
export default node;
